<template>

  <div class="transactions-table-section">
    <div class="headbar-label">تاریخچه تراکنش ها</div>

    <div class="filters">
      <div class="switch-comp" :style="{maxWidth:'288px'}" v-if="transactionsCurrencyType!=='Gold'">
        <button class="switch-comp-button" :class="{'active-opt':transactionsCurrencyType!=='Rial' }"
                @click="transactionsCurrencyType='Crypto'">تراکنش رمزارزی
        </button>
        <button class="switch-comp-button" :class="{'active-opt':transactionsCurrencyType==='Rial' }"
                @click="transactionsCurrencyType='Rial'">تراکنش ریالی
        </button>
      </div>
      <div class="switch-comp" :style="{maxWidth:'214px'}" v-if="transactionsCurrencyType!=='Rial' ">
        <button class="switch-comp-button" :class="{'active-opt':transactionsCurrencyType==='Crypto' }"
                @click="transactionsCurrencyType='Crypto'">رمزارز
        </button>
        <button class="switch-comp-button" :class="{'active-opt':transactionsCurrencyType==='Gold' }"
                @click="transactionsCurrencyType='Gold'">طلا و سکه
        </button>
      </div>

    </div>
    <div class="filters">
      <div class="switch-comp" :style="{maxWidth:'214px'}">
        <button class="switch-comp-button" :class="{'active-opt':transactionsType==='WITHDRAW' }"
                @click="transactionsType='WITHDRAW'">برداشت
        </button>
        <button class="switch-comp-button" :class="{'active-opt':transactionsType==='DEPSOIT' }"
                @click="transactionsType='DEPSOIT'">واریز
        </button>
      </div>
      <div class="filters-icon" @click="filtersShow=true">
        <img src="../../../../assets/icon/filters-icon.svg"/>
        <span>فیلترها</span>
      </div>

    </div>
    <div class="table-container">
<!-- rial transactions -->
      <table class="table" v-if="transactionsCurrencyType==='Rial'">
        <tr class="table-header">
          <td class="resp-1">زمان و تاریخ</td>
          <td>مقدار(تومان)</td>
          <td class="resp-2">بانک|شماره شبا</td>
          <td class="resp-1">شماره پیگیری</td>
          <td>وضعیت</td>
        </tr>
      <template v-if="transactionsType=='WITHDRAW'">
          <tr class="table-row" v-for="(transaction,index) in withdrawTomanTransactions" :key="index"  >
        
          <td class="resp-1">{{ $G2J(transaction.createdAtDateTime) }}</td>
          <td>{{ transaction.amount }}</td>
          <td class="resp-1">{{ transaction.destinationWalletAddress }}</td>


          <td class="details resp-2">مشاهده جزئیات</td>
            <td :class="{positive:transaction.condition==='SUCCESS',negative:transaction.transactionStatus==='FAIL',}">
            {{ dict[transaction.transactionStatus] }}
          </td>
        </tr>
</template>
<template v-if="transactionsType!=='WITHDRAW'">
          <tr class="table-row" v-for="(transaction,index) in depositTomanTransactions" :key="index"  >
         
          <td class="resp-1">{{ $G2J(transaction.createdAtDateTime) }}</td>
          <td>{{ transaction.amount }}</td>
          <td class="resp-1">{{ transaction.destinationWalletAddress }}</td>

          <td>
            {{transaction.id}}
          </td>
          <td class="details resp-2">مشاهده جزئیات</td>
    
        </tr>
</template>

      </table>

<!-- crypto transactions -->
      <table class="table" v-if="transactionsCurrencyType==='Crypto'">
        <tr class="table-header">
          <td> ارز</td>
          <td class="resp-1">زمان و تاریخ</td>
          <td>مقدار</td>
          <td class="resp-3">کارمزد</td>
          <td class="resp-3">شبکه</td>
          <td class="resp-1">آدرس مقصد</td>
          <td class="resp-2">شناسه تراکنش</td>
          <td> وضعیت</td>
        </tr>
<template v-if="transactionsType=='WITHDRAW'">
          <tr class="table-row" v-for="(transaction,index) in filterTransactions(withdrawCryptoTransactions)" :key="index"  >
          <td>
            <div class="coin-img-title">
              <img class="resp-2" :src="require('../../../../assets/coins/'+$coinUnit[transaction.relatedCoin]+'.svg' )" width="28" height="28"/>
              <div class="coin-symbol-title">
                <div class="coin-title"> {{ $coinLabel[transaction.relatedCoin] }}</div>
                <div class="coin-symbol"> {{ $coinUnit[transaction.relatedCoin] }}</div>
              </div>
            </div>
          </td>
          <td class="resp-1">{{ $G2J(transaction.createdAtDateTime) }}</td>
          <td>{{ transaction.amount }}</td>
          <td class="resp-3"> %{{ state.userInfo.fee }}</td>
          <td class="resp-3">{{ transaction.tokenType }}</td>
          <td class="resp-1">{{ transaction.destinationWalletAddress }}</td>
  <td :class="{positive:transaction.transactionStatus==='SUCCESS',negative:transaction.transactionStatus==='FAIL',}">
            {{ transaction.id }}
          </td>
          <td class="details resp-2">مشاهده جزئیات</td>
        </tr>
</template>
<template v-if="transactionsType!=='WITHDRAW'">
          <tr class="table-row" v-for="(transaction,index) in filterTransactions(depositCryptoTransactions)" :key="index"  >
          <td>
            <div class="coin-img-title">
              <img class="resp-2" :src="require('../../../../assets/coins/'+$coinUnit[transaction.relatedCoin]+'.png' )" width="28" height="28"/>
              <div class="coin-symbol-title">
                <div class="coin-title"> {{ $coinLabel[transaction.relatedCoin] }}</div>
                <div class="coin-symbol"> {{ $coinUnit[transaction.relatedCoin] }}</div>
              </div>
            </div>
          </td>
          <td class="resp-1">{{ $G2J(transaction.createdAtDateTime) }}</td>
          <td>{{ transaction.amount }}</td>
          <td class="resp-3">{{ state.userInfo.fee }}</td>
          <td class="resp-3">{{ transaction.tokenType }}</td>
          <td class="resp-1">{{ !transaction.bankAccount?'مقصد نامشخص':tra
            .bankAccount }}</td>
  <td :class="{positive:transaction.depositRequestStatus==='SUCCESS',negative:transaction.depositRequestStatus==='FAIL',}">
            {{ transaction.id }}
          </td>
          <td class="details resp-2">مشاهده جزئیات</td>
        </tr>
</template>


      </table>

<!-- gold transactions -->
      <table class="table" v-if="transactionsCurrencyType==='Gold'">
        <tr class="table-header">
          <td> ارز</td>
          <td class="resp-1"> زمان و تاریخ</td>
          <td>مقدار</td>
          <td class="resp-3">کارمزد</td>
          <td class="resp-3">شبکه</td>
          <td class="resp-1">آدرس مقصد</td>
          <td class="resp-1">شناسه تراکنش</td>
          <td> وضعیت</td>
        </tr>
        <tr class="table-row" v-for="(transaction,index) in filterTransactions(goldTransactios)" :key="index">
          <td>
            <div class="coin-img-title">
              <img class="resp-2" :src="require('../../../../assets/coins/'+transaction.coinName+'.svg')"/>
              <div class="coin-symbol-title">
                <div class="coin-title">{{ transaction.title }}</div>
              </div>
            </div>
          </td>
          <td class="resp-1">{{ transaction.date }}</td>
          <td>{{ transaction.amount }}</td>
          <td class="resp-3">{{ transaction.commission }}</td>
          <td class="resp-3">{{ transaction.network }}</td>
          <td class="resp-1">{{ transaction.walletAddress }}</td>
          <td class="details resp-1">مشاهده جزئیات</td>
          <td :class="{positive:transaction.condition==='SUCCESS',negative:transaction.condition==='FAIL',}">
            {{ dict[transaction.condition] }}
          </td>
        </tr>
      </table>
    </div>



<FiltersModal @close="filtersShow=false" @filterSelect="value => query=value" v-if="filtersShow" />
 


  </div>

</template>

<script>
import FiltersModal from './FiltersModal.vue'
import dataSet from './dataSet.json'

export default {
  name: "TransactionsTable",
  components:{
      FiltersModal
  },
  data() {
    return {
      query:{
        coin:{
          code:'',
          coin:'',
          persianName:''
        }
      },
      filtersShow:false,
      newestFilter:true,
      goldTransactios: [
        {
          "coinName": "tamam",
          "title": "تمام سکه",
          "transType": "WITHDRAW",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "SUCCESS",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "nim",
          "title": "نیم سکه",
          "transType": "DEPSOIT",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "SUCCESS",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "tamam",
          "title": "تمام سکه",
          "transType": "WITHDRAW",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "FAIL",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "nim",
          "title": "نیم سکه",
          "transType": "WITHDRAW",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "FAIL",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "rob",
          "title": "ربع سکه",
          "transType": "DEPSOIT",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "SUCCESS",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "tamam",
          "title": "تمام سکه",
          "transType": "WITHDRAW",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "FAIL",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "rob",
          "title": "ربع سکه",
          "transType": "DEPSOIT",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "SUCCESS",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },
        {
          "coinName": "mesghal",
          "title": "مثقال",
          "transType": "DEPSOIT",
          "commission": "0.4%",
          "date": "۱۵:۱۱ ",
          "condition": "FAIL",
          "amount": 0.12,
          "walletAddress": "0x33a2270bab20",
          "transId": "323323",
          "network": "ERC20"
        },


      ],
      withdrawCryptoTransactions:[],
      depositCryptoTransactions:[],
       withdrawTomanTransactions:[],
      depositTomanTransactions:[],
      transactions: dataSet.dataSet,
      //Crypto,Rial,Gold
      transactionsCurrencyType: 'Crypto',
      transactionsType: 'WITHDRAW',
      dict: {"SUCCESS": "موفق", 'FAIL': "ناموفق", "WITHDRAW": 'برداشت', "DEPSOIT": 'واریز', "RAISED_BY_USER":'شارژ شده توسط کاربر' , "PENDING": 'در انتظار'},

    }
  },
  methods: {



    

    filterTransactions(transactions) {
      const query = this.query
   console.log(this.query.coin.coin)
if(this.query.coin.coin==''){
  return transactions
}
else{
        return transactions.filter(transaction => {

      if (transaction.relatedCoin.includes(query.coin[0])) {
      console.log( 'transactions:',transactions)
          
          return transaction
        }
        // return transaction
      })
}
    },
      async getWithdrawCryptoFromServer(){
        let response = await this.$axios.get('/wallets/withdrawal-requests',{
          params:{
            size:1000
          }
        })
        response = response.content
    

            this.withdrawCryptoTransactions =  response.filter(transaction => { return transaction.relatedCoin !=='TOMAN'})
            this.withdrawTomanTransactions = response.filter(transactions=> { return transactions.relatedCoin ==='TOMAN'})
              // console.log('cryptowithdrawal:', this.withdrawCryptoTransactions , 'tomanwithdrawal:', this.withdrawTomanTransactions)









        
    },
      async getDepositCryptoFromServer(){
    let response = await this.$axios.get('/wallets/deposit')
    response = response.content


    
    this.depositCryptoTransactions =  response.filter(transaction => { return transaction.relatedCoin !=='TOMAN'})
    this.depositTomanTransactions = response.filter(transactions=> { return transactions.relatedCoin ==='TOMAN'})
      // console.log('cryptodeposit:', this.depositCryptoTransactions , 'tomanDeposit:', this.depositTomanTransactions)
    


  },

  },
  mounted() {
    this.getWithdrawCryptoFromServer()
    this.getDepositCryptoFromServer()


  },
}
</script>

<style scoped>

.filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 10px;
  justify-content: space-between;
  margin-top: 30px;
}
.table-container{
  max-height: 400px;
  overflow-y:scroll ;
  margin-top: 60px;

}
.details {
  color: #1199FA;
  text-decoration: underline;
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(119, 119, 119, 0.2);
}

td{
  padding: 9px 0;

}
.table-header > td:last-child{
   padding: 30px 0px;
}
td:last-child{
  text-align: left;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(119, 119, 119, 0.3);

  border-radius: 20px;
}

/*td:last-child{*/
/*  border: 1px solid white;*/
/*}*/
.filters-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #1199FA;
  font-size: clamp(14px, 1.5vw, 16px);
  column-gap: 6px;
}

.active-opt {
  background: rgba(215, 200, 200, 0.12) !important;
  color: rgba(17, 153, 250, 1) !important;
}

.switch-comp {
  display: flex;
  align-items: center;
  column-gap: 7px;
  min-width: 150px;
  flex-grow: 1;
}

.switch-comp-button {
  background: transparent;
  color: rgba(215, 200, 200, 1);
  border-radius: 4px;
  border: 0.5px solid rgba(215, 200, 200, 0.35);
  cursor: pointer;
  font-size: clamp(10px, 1.1vw, 12px);
  height: 25px;
  flex-grow: 1;
}


.table-header {
  color: #D7C8C8;
  flex-grow: 1;
  font-weight: bold;
  margin-bottom: 27px;
  position: sticky;
  top: 0;
  background: #091222;

}

.table-row {
  margin-top: 8px;
  align-items: center;
  min-height: 45px;
  color: #D7C8C8 !important;
  font-size: clamp(12px, 1.3vw, 14px) !important;


}

td {
  font-size: clamp(12px, 1.3vw, 14px) !important;
}

.positive {
  color: #04B3A2;
}

.negative {
  color: #D94F68;
}

.coin-img-title {
  display: flex;
  column-gap: 8px;
  align-items: center;
  color: #D7C8C8;
}

.coin-title {
  font-size: clamp(12px, 1.3vw, 14px);
}

.coin-symbol {
  font-size: clamp(9px, 1.1vw, 10px);

}

/*btns*/




.headbar-label {
  font-size: clamp(14px, 1.5vw, 16px);
  color: #FFFFFF;
}

.transactions-table-section {
  min-height: 550px;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: clamp(15px, 2.5vw, 40px) clamp(15px, 2.5vw, 40px) clamp(15px, 2vw, 30px) clamp(15px, 2vw, 30px);
  flex-grow: 1;
}



@media(max-width:1200px){

  .resp-1{
    display: none;
  }
}
@media(max-width:900px){
  .resp-2{
    display: none;
  }
}

@media(max-width:600px){
  .resp-3{
    display: none;
  }
}
</style>